

export const generateTimeOptions = (groupla) => {
    if (groupla === 'Floreasca') {
        console.log('sambata');
        return ['18:30', '19:30', '20:30'];
    } else {
        return ['16:00', '17:00', '18:00', '19:00', '20:00'];
    }
}

export const isDateLessThan30DaysAgo = (date) => {
    const today = new Date();
    const dateToCheck = new Date(date);
    const diffTime = Math.abs(today - dateToCheck);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays < 30;
}


/**
 * Splits the group and time strings into arrays.
 * If multiple groups and times are provided, split them.
 * If multiple groups and one time is provided, set the same time for all groups
 * @param {*} group 
 * @param {*} time 
 * @returns Array of {group, time} objects
 */
export function splitGroupAndTimes(group, time) {
    let groups = group.split('-').map(g => g.trim());
    let times = time.split('-').map(t => t.trim());

    if (groups.length > 1 && times.length === 1) {
        return groups.map(g => ({ group: g, time: times[0] }));
    } else if (groups.length === 1 && times.length > 1) {
        return times.map(t => ({ group: groups[0], time: t }));
    } else if (groups.length > 1 && times.length > 1) {
        // Make sure both arrays have the same length
        if (groups.length < times.length) {
            // If there are more times than groups, repeat the last group
            const lastGroup = groups[groups.length - 1];
            while (groups.length < times.length) {
                groups.push(lastGroup);
            }
        } else if (times.length < groups.length) {
            // If there are more groups than times, repeat the last time
            const lastTime = times[times.length - 1];
            while (times.length < groups.length) {
                times.push(lastTime);
            }
        }

        return groups.map((g, i) => ({ group: g, time: times[i] }));
    } else {
        return [{ group: groups[0], time: times[0] }];
    }
}